/** Fade-in animation with 250ms delay — prevents visual flicker during async loading. */
export const delayedFadeInSx = {
  opacity: 0,
  visibility: 'hidden',
  animation: 'fadeIn 500ms 250ms ease-in forwards',
  '@keyframes fadeIn': {
    from: { opacity: 0, visibility: 'hidden' },
    to: { opacity: 1, visibility: 'visible' },
  },
} as const;
